import React from 'react';

export const ConveyanceIcon = ({ width = 16, height = 12, className = '', color = '', onClick }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      //fill="#cc0000"
      onClick={onClick}
      role="button"
      aria-label="toggle trip search"
    >
      <path
        d="M13.3334 3.33333H11.3334V0.666664H2.00008C1.26675 0.666664 0.666748 1.26666 0.666748 2V9.33333H2.00008C2.00008 10.44 2.89341 11.3333 4.00008 11.3333C5.10675 11.3333 6.00008 10.44 6.00008 9.33333H10.0001C10.0001 10.44 10.8934 11.3333 12.0001 11.3333C13.1067 11.3333 14.0001 10.44 14.0001 9.33333H15.3334V6L13.3334 3.33333ZM4.00008 10.3333C3.44675 10.3333 3.00008 9.88666 3.00008 9.33333C3.00008 8.78 3.44675 8.33333 4.00008 8.33333C4.55341 8.33333 5.00008 8.78 5.00008 9.33333C5.00008 9.88666 4.55341 10.3333 4.00008 10.3333ZM13.0001 4.33333L14.3067 6H11.3334V4.33333H13.0001ZM12.0001 10.3333C11.4467 10.3333 11.0001 9.88666 11.0001 9.33333C11.0001 8.78 11.4467 8.33333 12.0001 8.33333C12.5534 8.33333 13.0001 8.78 13.0001 9.33333C13.0001 9.88666 12.5534 10.3333 12.0001 10.3333Z"
        fill="#cc0000"
      />
    </svg>
  );
};

export default ConveyanceIcon;
